import { useEffect, useState } from 'react'
import { Button, type ButtonProps } from '@chakra-ui/react'

type ButtonWithTimerProps = ButtonProps & {
  timerInterval: number
  handleClick?: () => void
}

export const ButtonWithTimer = ({
  timerInterval,
  handleClick,
  ...props
}: ButtonWithTimerProps) => {
  const [isActive, setIsActive] = useState(false)
  const [resendTimer, setResendTimer] = useState(timerInterval)

  const onClick = () => {
    if (!isActive) return
    setIsActive(false)
    setResendTimer(timerInterval)
    handleClick?.()
  }

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined
    if (resendTimer > 0) {
      timer = setTimeout(() => {
        setResendTimer(resendTimer - 1)
      }, 1000)
    } else {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsActive(true)
    }

    return () => {
      if (timer) {
        clearTimeout(timer)
      }
    }
  }, [resendTimer])

  return (
    <Button
      w="100%"
      h="52px"
      fontSize="14px"
      fontWeight={500}
      borderRadius="10px"
      color={isActive ? 'white' : 'text.tertiary'}
      bg={isActive ? 'accent.500' : 'bg.surface'}
      border="1px solid"
      borderColor={isActive ? 'accent.500' : 'border.subtle'}
      cursor={isActive ? 'pointer' : 'not-allowed'}
      transition="all 0.2s ease"
      _hover={
        isActive
          ? {
              bg: 'accent.400',
              boxShadow: '0 0 24px rgba(0, 112, 243, 0.25)'
            }
          : {}
      }
      {...props}
      onClick={onClick}
    >
      {isActive ? 'Resend Code' : `Resend in ${resendTimer}s...`}
    </Button>
  )
}
